<div class="modal-content">
  <div class="modal-header align-items-center">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">{{ 'manageEvent.editSponsor.title' | translate }}</h2>
      <p class="text-muted small mb-0">{{ 'common.requiredFieldsHint' | translate }}</p>
    </div>
    <i class="fa-solid fa-xmark fs-2 cursor-pointer" (click)="close()"></i>
  </div>

  <div class="modal-body">
    <div class="row">
      <h3>{{ 'manageEvent.editSponsor.sponsorInfo' | translate }}</h3>
    </div>

    <div class="row spacing-15">
      <div class="col-12">
        <app-input-component
          [label]="('manageEvent.editSponsor.sponsorName' | translate) + ' *'"
          [type]="'text'"
          [placeholder]="'manageEvent.editSponsor.sponsorNamePlaceholder' | translate"
          [(value)]="sponsor_name"
          [invalid]="isSponsorNameInvalid"
        />
      </div>
    </div>

    <div class="row spacing-15">
      <div class="col-12">
        <app-input-component
          [label]="'manageEvent.editSponsor.sponsorDescription' | translate"
          [type]="'text'"
          [placeholder]="'manageEvent.editSponsor.sponsorDescriptionPlaceholder' | translate"
          [(value)]="sponsor_description"
        />
      </div>
    </div>

    <div class="row spacing-30">
      <div class="col-12">
        <h4>{{ 'manageEvent.editSponsor.logo' | translate }}</h4>
        @if (sponsor.logo_url) {
          <div class="mb-3 d-flex align-items-center">
            <span class="me-3 text-muted">{{ 'manageEvent.editSponsor.current' | translate }}:</span>
            <img [src]="sponsor.logo_url" alt="Current logo" style="max-width: 150px; max-height: 150px; object-fit: contain; border: 1px solid #e0e0e0; border-radius: 4px; padding: 8px;">
          </div>
        }
        <app-fileorini
          [accept]="'image/*'"
          (filesChanged)="onLogoSelected($event)"
        />
        @if (logoPreview) {
          <div class="mt-3 d-flex align-items-center">
            <span class="me-3 text-success">{{ 'manageEvent.editSponsor.new' | translate }}:</span>
            <img [src]="logoPreview" alt="New logo" style="max-width: 150px; max-height: 150px; object-fit: contain; border: 1px solid #4caf50; border-radius: 4px; padding: 8px;">
          </div>
        }
      </div>
    </div>

    <div class="row spacing-30">
      <div class="col-12">
        <h4>{{ 'manageEvent.editSponsor.bannerImage' | translate }}</h4>
        @if (sponsor.image_url) {
          <div class="mb-3 d-flex align-items-center">
            <span class="me-3 text-muted">{{ 'manageEvent.editSponsor.current' | translate }}:</span>
            <img [src]="sponsor.image_url" alt="Current banner" style="max-width: 150px; max-height: 150px; object-fit: contain; border: 1px solid #e0e0e0; border-radius: 4px; padding: 8px;">
          </div>
        }
        <app-fileorini
          [accept]="'image/*'"
          (filesChanged)="onImageSelected($event)"
        />
        @if (imagePreview) {
          <div class="mt-3 d-flex align-items-center">
            <span class="me-3 text-success">{{ 'manageEvent.editSponsor.new' | translate }}:</span>
            <img [src]="imagePreview" alt="New banner" style="max-width: 150px; max-height: 150px; object-fit: contain; border: 1px solid #4caf50; border-radius: 4px; padding: 8px;">
          </div>
        }
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-12 d-flex justify-content-end">
        <app-button
          [variant]="'primary'"
          [label]="saving ? ('common.saving' | translate) : ('manageEvent.editSponsor.updateSponsor' | translate)"
          [iconClass]="saving ? 'fa fa-spinner fa-spin' : 'fa fa-save'"
          [disabled]="saving"
          (clicked)="onSave()"
        />
      </div>
    </div>
  </div>
</div>
